
import artistImage from "../images/kevinHart.png"
import AlbumArt from "../images/drake.jpg"
import fikFameika from "../images/fikfameika.jpg"
import eddykenzo from "../images/eddykenzo.jpg"
import dabber from "../images/dabber.jpg"
import chameleone from  "../images/chameleone.jpg"
import bing from  "../images/bing.png"

import slide1 from "../images/slides/img1.jpg"
import slide2 from "../images/slides/img2.jpg"
import slide3 from "../images/slides/img3.jpg"
import slide4 from "../images/slides/img4.jpg"
import slide5 from "../images/slides/img5.jpg"

const UgandanMix =`Ugandan Mix`
const AfroBeats =`Afro beats`
const Gospel =`Gospel`
const KadongoKamu =`Kadongo Kamu`
const LugaFlow =`Luga Flow`

const aboutText = "entum. Cras ligula purus, ultricies eget accumsan sit amet, consequat vitae justo. Mauris aliquam, enim in facilisis commodo, ligula nibh cursus tellus, vitae mollis est tortor et justo. Sed non sagittis nunc. Fusce a ullamcorper velit, ac tempor tellus. Nullam varius non nunc vel viverra. Cras vel lacus eu erat elementum rhoncus. Nulla facilisi. Morbi a justo sit amet ante aliquet luctus venenatis quis mi. Sed consequat dolor sit amet augue pharetra scelerisque. Pellentesque mollis ac urna ut volutpat.";
const lyrics = "entum. Cras ligula purus, ultricies eget accumsan sit amet, consequat vitae justo. Mauris aliquam, enim in facilisis commodo, ligula nibh cursus tellus, vitae mollis est tortor et justo. Sed non sagittis nunc. Fusce a ullamcorper velit, ac tempor tellus. Nullam varius non nunc vel viverra. Cras vel lacus eu erat elementum rhoncus. Nulla facilisi. Morbi a justo sit amet ante aliquet luctus venenatis quis mi. Sed consequat dolor sit amet augue pharetra scelerisque. Pellentesque mollis ac urna ut volutpat.";


const databaseJson =  {

   Music: [
        {
            "artistName":"Jose Chameleone",
            "aboutArtist": aboutText,
            "artistGenre" : ["Afro beat", "Dancehall"],
            "artistImage": chameleone,
            "albums":[
                {
                    "albumTitle":"Mama Africa",
                    "albumDescription":"this albums is about love for the continent of africa",
                    "coverimage":AlbumArt,
                    "songs":[
                        {
                            "title":"befuula",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        },
                        {
                            "title":"kuuma obwesigwa",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        },
                        {
                            "title":"vvumilia",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }, {
                            "title":"mama africa",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }
                            ],
                },
                {
                    "albumTitle":"unknown",
                    "albumDescription":"",
                    "coverimage":AlbumArt,
                    "songs":[
                        {
                            "title":"sivyo ndivyi",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }
                            ],
                   
                }
                    ]
        },
        {
            "artistName":"Bobiwine",
            "aboutArtist": aboutText,
            "artistGenre" : ["Afro beat", "Dancehall"],
            "artistImage": chameleone,
            "albums":[
                {
                    "albumTitle":"Mama Africa",
                    "albumDescription":"this albums is about love for the continent of africa",
                    "coverimage":AlbumArt,
                    "songs":[
                        {
                            "title":"befuula",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        },
                        {
                            "title":"kuuma obwesigwa",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        },
                        {
                            "title":"vvumilia",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }, {
                            "title":"mama africa",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }
                            ],
                },
                {
                    "albumTitle":"unknown",
                    "albumDescription":"",
                    "coverimage":eddykenzo,
                    "songs":[
                        {
                            "title":"sivyo ndivyi",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }
                            ],
                   
                }
                    ]
        },
        {
            "artistName":"Eddy kenzo",
            "aboutArtist": aboutText,
            "artistGenre" : ["Afro beat", "Dancehall"],
            "artistImage": eddykenzo,
            "albums":[
                {
                    "albumTitle":"Mama Africa",
                    "albumDescription":"this albums is about love for the continent of africa",
                    "coverimage":AlbumArt,
                    "songs":[
                        {
                            "title":"befuula",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        },
                        {
                            "title":"kuuma obwesigwa",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        },
                        {
                            "title":"vvumilia",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }, {
                            "title":"mama africa",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }
                            ],
                },
                {
                    "albumTitle":"unknown",
                    "albumDescription":"",
                    "coverimage":AlbumArt,
                    "songs":[
                        {
                            "title":"sivyo ndivyi",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }
                            ],
                   
                }
                    ]
        },
        {
            "artistName":"John blaq",
            "aboutArtist": aboutText,
            "artistGenre" : ["Afro beat", "Dancehall"],
            "artistImage": fikFameika,
            "albums":[
                {
                    "albumTitle":"Mama Africa",
                    "albumDescription":"this albums is about love for the continent of africa",
                    "coverimage":AlbumArt,
                    "songs":[
                        {
                            "title":"befuula",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        },
                        {
                            "title":"kuuma obwesigwa",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        },
                        {
                            "title":"vvumilia",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }, {
                            "title":"mama africa",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }
                            ],
                },
                {
                    "albumTitle":"unknown",
                    "albumDescription":"",
                    "coverimage":AlbumArt,
                    "songs":[
                        {
                            "title":"sivyo ndivyi",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }
                            ],
                   
                }
                    ]
        },
        {
            "artistName":"Fik fameika",
            "aboutArtist": aboutText,
            "artistGenre" : ["Afro beat", "Dancehall"],
            "artistImage": fikFameika,
            "albums":[
                {
                    "albumTitle":"Mama Africa",
                    "albumDescription":"this albums is about love for the continent of africa",
                    "coverimage":bing,
                    "songs":[
                        {
                            "title":"vvumilia",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }, {
                            "title":"mama africa",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }
                            ],
                },
                {
                    "albumTitle":"unknown",
                    "albumDescription":"",
                    "coverimage":AlbumArt,
                    "songs":[
                        {
                            "title":"sivyo ndivyi",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }
                            ],
                   
                }
                    ]
        },
        {
            "artistName":"Bebecool",
            "aboutArtist": aboutText,
            "artistGenre" : ["Afro beat", "Dancehall"],
            "artistImage": artistImage,
            "albums":[
                {
                    "albumTitle":"Mama Africa",
                    "albumDescription":"this albums is about love for the continent of africa",
                    "coverimage":AlbumArt,
                    "songs":[
                        {
                            "title":"befuula",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        },
                        {
                            "title":"kuuma obwesigwa",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        },
                        {
                            "title":"vvumilia",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }, {
                            "title":"mama africa",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }
                            ],
                },
                {
                    "albumTitle":"unknown",
                    "albumDescription":"",
                    "coverimage":AlbumArt,
                    "songs":[
                        {
                            "title":"sivyo ndivyi",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }
                            ],
                   
                }
                    ]
        },
        {
            "artistName":"Lord fred ssebatta",
            "aboutArtist": aboutText,
            "artistGenre" : ["Afro beat", "Dancehall"],
            "artistImage": dabber,
            "albums":[
                {
                    "albumTitle":"Mama Africa",
                    "albumDescription":"this albums is about love for the continent of africa",
                    "coverimage":AlbumArt,
                    "songs":[
                        {
                            "title":"befuula",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        },
                        {
                            "title":"kuuma obwesigwa",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        },
                        {
                            "title":"vvumilia",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }, {
                            "title":"mama africa",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }
                            ],
                },
                {
                    "albumTitle":"unknown",
                    "albumDescription":"",
                    "coverimage":AlbumArt,
                    "songs":[
                        {
                            "title":"sivyo ndivyi",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }
                            ],
                   
                }
                    ]
        },
        {
            "artistName":"Tip swizzy",
            "aboutArtist": aboutText,
            "artistGenre" : ["Afro beat", "Dancehall"],
            "artistImage": chameleone,
            "albums":[
                {
                    "albumTitle":"Mama Africa",
                    "albumDescription":"this albums is about love for the continent of africa",
                    "coverimage":AlbumArt,
                    "songs":[
                        {
                            "title":"befuula",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        },
                        {
                            "title":"kuuma obwesigwa",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        },
                        {
                            "title":"vvumilia",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }, {
                            "title":"mama africa",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }
                            ],
                },
                {
                    "albumTitle":"unknown",
                    "albumDescription":"",
                    "coverimage":AlbumArt,
                    "songs":[
                        {
                            "title":"sivyo ndivyi",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }
                            ],
                   
                }
                    ]
        },
        {
            "artistName":"Ykee benda",
            "aboutArtist": aboutText,
            "artistGenre" : ["Afro beat", "Dancehall"],
            "artistImage": chameleone,
            "albums":[
                {
                    "albumTitle":"Mama Africa",
                    "albumDescription":"this albums is about love for the continent of africa",
                    "coverimage":AlbumArt,
                    "songs":[
                        {
                            "title":"befuula",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        },
                        {
                            "title":"kuuma obwesigwa",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        },
                        {
                            "title":"vvumilia",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }, {
                            "title":"mama africa",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }
                            ],
                },
                {
                    "albumTitle":"unknown",
                    "albumDescription":"",
                    "coverimage":AlbumArt,
                    "songs":[
                        {
                            "title":"sivyo ndivyi",
                            "songFile":"trialSong",
                            "lyrics": lyrics,
                            "timesOfplay": 2400,
                            "dateUploaded": "3 years ago", 
                            "genre" : UgandanMix
                        }
                            ],
                   
                }
                    ]
        },
    ],

    SlidesArray:[
        {
            slideID : "0",
            "slideName": "slidename",
            "slideImage": slide1,
            "genre" : UgandanMix
        },
        {
            slideID : "1",
            "slideName": "slidename",
            "slideImage": slide2,
            "genre" : AfroBeats
        },
        {
            slideID : "2",
            "slideName": "slidename",
            "slideImage": slide3,
            "genre" : Gospel
        },
        {
            slideID : "3",
            "slideName": "slidename",
            "slideImage": slide4,
            "genre" : KadongoKamu
        },
        {
            slideID : "4",
            "slideName": "slidename",
            "slideImage": slide5,
            "genre" : LugaFlow
        }
    ]

};





export default databaseJson;